"use strict";
exports.__esModule = true;
exports.setupTvProgramApi = exports.setupEshopApi = exports.setupCoreApi = exports.setupMediamanagerApi = exports.setupCompetitionsApi = exports.setupCalendarApi = exports.setupCmsApi = void 0;
var tslib_1 = require("tslib");
var CalendarApi_1 = tslib_1.__importDefault(require("./CalendarApi"));
var CmsApi_1 = tslib_1.__importDefault(require("./CmsApi"));
var CompetitionsApi_1 = tslib_1.__importDefault(require("./CompetitionsApi"));
var CoreApi_1 = tslib_1.__importDefault(require("./CoreApi"));
var EshopApi_1 = tslib_1.__importDefault(require("./EshopApi"));
var MediamanagerApi_1 = tslib_1.__importDefault(require("./MediamanagerApi"));
var TvProgramApi_1 = tslib_1.__importDefault(require("./TvProgramApi"));
function setupCmsApi() {
    CmsApi_1["default"].setBaseUrl(process.env.REACT_APP_CMS_API_BASE_URL ||
        'https://cms.sportnet.online/api/v3');
}
exports.setupCmsApi = setupCmsApi;
function setupCalendarApi() {
    CalendarApi_1["default"].setBaseUrl(process.env.REACT_APP_CALENDAR_API_BASE_URL ||
        'https://calendar.sportnet.online/api/v1');
}
exports.setupCalendarApi = setupCalendarApi;
function setupCompetitionsApi() {
    CompetitionsApi_1["default"].setBaseUrl(process.env.REACT_APP_COMPETITIONS_API_BASE_URL ||
        'https://api.sutaze.sportnet.online/api/v1');
}
exports.setupCompetitionsApi = setupCompetitionsApi;
function setupMediamanagerApi() {
    MediamanagerApi_1["default"].setBaseUrl(process.env.REACT_APP_MEDIAMANAGER_API_BASE_URL ||
        'https://mediamanager.sportnet.online/api');
}
exports.setupMediamanagerApi = setupMediamanagerApi;
function setupCoreApi() {
    CoreApi_1["default"].setBaseUrl(process.env.REACT_APP_CORE_API_BASE_URL || 'https://api.sportnet.online/v1');
}
exports.setupCoreApi = setupCoreApi;
function setupEshopApi() {
    EshopApi_1["default"].setBaseUrl(process.env.REACT_APP_ESHOP_API_BASE_URL ||
        'https://eshop.sportnet.online/api/v2');
}
exports.setupEshopApi = setupEshopApi;
function setupTvProgramApi() {
    TvProgramApi_1["default"].setBaseUrl(process.env.REACT_APP_TVPROGRAM_API_BASE_URL ||
        'https://tvprogram.sportnet.sk/api/v1');
}
exports.setupTvProgramApi = setupTvProgramApi;
exports["default"] = (function () {
    setupCmsApi();
    setupCalendarApi();
    setupCompetitionsApi();
    setupMediamanagerApi();
    setupCoreApi();
    setupEshopApi();
    setupTvProgramApi();
});
